module.exports = __webpack_public_path__ + "static/media/helmet.de64fc78.svg";